<!-- 👇 ANIMATED GOLD SPARKLES (20 particles) -->
<div class="particle" *ngFor="let i of [].constructor(20)"></div>


<!-- 👇 HEADER -->
<header>
  <nav>
    <a href="/" class="logo">
      <img src="/images/wealthlane-logo.svg" width="26" height="34">
      <span>ealthlane</span>
    </a>
    <div class="nav-right">
      <a href="/" class="btn-secondary">Retour à l'accueil</a>
    </div>
  </nav>
</header>

<!-- 👇 LOGIN SECTION -->
<div class="login-wrapper">
  <div class="login-container">

    <!-- 👇 LEFT PANEL -->
    <div class="login-left">
      <div class="login-left-content">
        <h1>De la comptabilité à la gestion de patrimoine</h1>
        <p>Vous êtes à un clic de créer une nouvelle source de revenus avec vos clients qui vous font confiance !</p>

        <!-- 👇 STATS GRID -->
        <div class="stats-grid">
          <div class="stat-item">
            <div class="stat-number">+45k€</div>
            <div class="stat-label">Revenus dès la 1ère année</div>
          </div>
          <div class="stat-item">
            <div class="stat-number">5 min</div>
            <div class="stat-label">Bilan patrimonial généré</div>
          </div>
          <div class="stat-item">
            <div class="stat-number">50+</div>
            <div class="stat-label">Stratégies patrimoniales</div>
          </div>
          <div class="stat-item">
            <div class="stat-number">100%</div>
            <div class="stat-label">Analyse automatisée par IA</div>
          </div>
        </div>
      </div>

      <div class="login-footer">
        💎 Wealthlane - Conseil patrimonial pour experts-comptables
      </div>
    </div>

    <!-- 👇 RIGHT PANEL -->
    <div class="login-right">
      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="login-form">
        <h2>Se connecter</h2>
        <p class="login-form-subtitle">Accédez à votre espace Wealthlane</p>

        <!-- 👇 EMAIL INPUT -->
        <div class="form-group">
          <label for="email">Email</label>
          <input type="email" id="email" formControlName="email" placeholder="user1@example.com" (input)="clearErrors()"
            required>
        </div>
        <!-- 👇 EMAIL ERRORS -->
        <div class="error-message" *ngIf="submitted && loginForm.controls['email'].errors?.['required']">
          Email est requis
        </div>
        <div class="error-message" *ngIf="submitted && loginForm.controls['email'].errors?.['email']">
          Email est invalide
        </div>

        <!-- 👇 PASSWORD INPUT -->
        <div class="form-group">
          <label for="password">Mot de passe</label>
          <input type="password" id="password" formControlName="password" placeholder="••••••••••"
            (input)="clearErrors()" required>
          <div class="forgot-password">
            <a href="#/forgot-password">Mot de passe oublié ?</a>
          </div>
        </div>
        <!-- 👇 PASSWORD ERRORS -->
        <div class="error-message" *ngIf="submitted && loginForm.controls['password'].errors?.['required']">
          Mot de passe est requis
        </div>

        <!-- 👇 GENERAL ERROR MESSAGE -->
        <div class="error-message" *ngIf="errorMessage">
          {{ errorMessage }}
        </div>

        <!-- 👇 LOGIN BUTTON -->
        <button type="submit" class="btn-login" [disabled]="loading">
          {{ loading ? 'Connexion en cours...' : 'Se connecter' }}
        </button>
      </form>

      <!-- 👇 DIVIDER -->
      <div class="divider">ou</div>

      <!-- 👇 GOOGLE BUTTON -->
      <button type="button" class="btn-google" (click)="loginWithGoogle()">
        <img src="/images/google-icon.svg" alt="Google Logo" width="20" height="20">
        Se connecter avec Google
      </button>

      <!-- 👇 SIGNUP LINK -->
      <div class="signup-link">
        Vous n'avez pas de compte ?
        <a routerLink="/register">Créer un compte gratuitement</a>
      </div>
    </div>
  </div>
</div>